module.exports =
{

  _init: function ()
  {
    APPLICATION._APPLICATION.processLinks('#orders', 'FibrePod', 'orders')
  }

}